<app-card *ngIf="ableToSee()"
  title="{{solutionSteps[Index].actionType.translationKey | translate}}"
  cardClass = "{{ cardIsActive ? '' : 'inactive' }}"
  [titleHasIcon]="cardIsActive"
  [titleIconActive] = "this.request.reply.replyItems[this.Index] && this.request.reply.replyItems[this.Index].isDone"
>
  <div *ngIf="solutionSteps[Index]" [ngSwitch]="solutionSteps[Index].actionType.name">
    <app-dealer-reply-step-confirmation *ngSwitchCase="'confirmation'" [Index]="Index" [isActive]="cardIsActive"></app-dealer-reply-step-confirmation>
    <app-dealer-reply-step-text *ngSwitchCase="'text'" [Index]="Index" [isActive]="cardIsActive"></app-dealer-reply-step-text>
    <app-dealer-reply-step-form *ngSwitchCase="'form'" [Index]="Index" [isActive]="cardIsActive"></app-dealer-reply-step-form>
    <app-dealer-reply-step-packaging-label *ngSwitchCase="'packaging_label'" [Index]="Index" [isActive]="cardIsActive"></app-dealer-reply-step-packaging-label>
    <app-dealer-reply-step-invoice *ngSwitchCase="'invoice'" [Index]="Index" [isActive]="cardIsActive"></app-dealer-reply-step-invoice>
    <app-dealer-reply-step-reorder *ngSwitchCase="'re_order'" [Index]="Index" [isActive]="cardIsActive"></app-dealer-reply-step-reorder>
  </div>
</app-card>
